<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <div>
          <b-button class="btn btn-danger" variant="none" @click="back">
            <i class="fa fa-chevron-left"></i> Back
          </b-button>
        </div>
        <b-card :header="appendtext + ' Vehicle Type Setup'" class="mt-1">
          <b-alert :show="isShowAlert" variant="success" isShowAlert="false">
            <p>
              Successfully {{ appendtext }}
              <b-button
                v-show="buttonishow"
                variant="primary"
                @click="reload"
                size="sm"
              >
                <i class="fa fa-plus-circle"></i>&nbsp;Vehicle Type
              </b-button>
            </p>
          </b-alert>

          <b-form @submit="onSubmit" v-if="!isShowAlert">
            <b-alert :show="errors.length > 0" variant="danger">
              <h6 class="alert-heading">Please fill in all required field!</h6>
              <ul>
                <li v-for="(error, i) in errors" :key="`error-${i}`">
                  {{ error }}
                </li>
              </ul>
            </b-alert>
            <b-form-group id="exampleInputGroup1" label="Fleet Type*">
              <b-form-input
                id="drpdata"
                class="form-control bg-white"
                v-model.trim="form.drpdata"
                
                placeholder="Input Fleet Type"
              />
              <!-- list="Fleet-Type-List-id" -->
                <datalist id="Fleet-Type-List-id">
                <option v-for="drpdata in items" :key="drpdata">{{drpdata}}</option>
                </datalist>
            </b-form-group>

            <b-form-group id="exampleInputGroup2" label="Description*">
              <b-form-input
                v-model.trim="form.drpdisplay"
                placeholder="Input Description"
              ></b-form-input>
            </b-form-group>

            <div class="dispatch-table">
              <b-button type="submit" variant="primary">
                <i class="fa fa-save"></i>
                {{ appendtext }}
              </b-button>
            </div>
            <div class="dispatch-list">
              <b-button
                type="submit"
                variant="primary"
                class="btn btn-primary btn-sm btn-block"
              >
                <i class="fa fa-save"></i>
                {{ appendtext }}
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    
    
  </div>
</template>

<script>
import api from "../../services/api";
import miniToastr from "mini-toastr";
import axios from "axios";
miniToastr.init();
export default {
  data() {
    return {
      
      errors: [],
      FleetType:'',
      items: [],
      isShowAlert: false,
      buttonishow: this.$route.params.id == undefined ? true : false,

      appendtext: this.$route.params.id == undefined ? "Create" : "Update",
      isDisabled: this.$route.params.id == undefined ? 0 : 1,

      form: {
      id:"",
      drpdata: "",
      drpdisplay: "",
      }
    };
  },
  
  methods: {
    checkForm: function (e) {
      if (
        this.form.drpdata &&
        this.form.drpdisplay 
      ) {
        return true;
      }

      this.errors = [];
      if (!this.form.drpdata) {
        this.errors.push("Fleet Type Required.");
      }
      if (!this.form.drpdisplay) {
        this.errors.push("Description required.");
      }

      // e.preventDefault();
    },
    onGetFleetType: function () {
      api.instance
        .get(this.$store.state.IFMSURLlocal + 
        "get-select-vehicletype?drpids=VEHICLE")
        .then((resp) => {
         this.items = resp.data.items;
        })
        // .then((resp) => {
        //     this.vehicletypelist = resp.results.map(v => {
        //         return v.drpdisplay
        //     })
        // })
        .catch(function (err) {
          api.httpMsg(this, err.status, err.data);
        });
    },

    onSubmit: function (evt) {
      evt.preventDefault();
      if (!this.checkForm()) {
        return;
      }
      this.$store.commit("setLoading", true);
      if (this.appendtext == "Create") {
        axios
        .post(
        this.$store.state.IFMSURLlocal +
          "add-fleet-type", this.form)
          .then(() => {
            this.isShowAlert = true;
            this.$store.commit("setLoading", false);
          })
          .catch(function (err) {
            api.httpMsg(this, err.status, err.data);
            this.$store.commit("setLoading", false);
          });
      } else if (this.appendtext == "Update") {
        axios
          .post(
            this.$store.state.IFMSURLlocal + 
            "edit-fleet-type", this.form
            )
            //   drpdata: this.form.drpdata,
            //   drpdisplay: this.form.drpdisplay
            // })
          .then(() => {
            this.isShowAlert = true;
            this.$store.commit("setLoading", false);
          })
          .catch(function (err) {
            this.$store.commit("setLoading", false);
            api.httpMsg(this, err.status, err.data);
          });
      }
    },
    reload: function () {
      this.$router.go(this.$router.currentRoute);
    },

    back: function () {
      this.$router.push("/Maintenance/637454377594731857");
    },
    SelectFleettype(val) {
      this.form.drpdata = val.drpdata;
      this.form.drpdisplay = val.drpdisplay;
    },
    
    getData: function () {
      let self = this;
      if (this.$route.params.id !== undefined) {
        self.$store.commit("setLoading", true);
        axios
          .get(this.$store.state.IFMSURLlocal + 
          "get-vehicletype-by-id?drpdata=" + 
          this.$route.params.id)
          .then((resp) => {
            self.form = resp.data;
            self.$store.commit("setLoading", false);
          })
          .catch((err) => {
            api.httpMsg(this, err.status, err.data);
            self.$store.commit("setLoading", false);
          });
      }
    },
  },
  
  created: function () {
    this.getData();
    this.onGetFleetType();
  },
};
</script>
